import { RadioButtonGroup } from '@sgme/ui';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { HistoricalDaterangePicker } from '@/App/Blotter/filters/HistoricalDaterangePicker.tsx';
import { useTrackEvent } from '@/App/Blotter/useTrackEvent.ts';
import { blotterSlice } from '@/store/blotter/slice.ts';
import { useAppSelector } from '@/store/hooks.ts';

type DateFilterType = 'intraday' | 'historical';

export const DateFilter = () => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  const track = useTrackEvent();

  const filter = useAppSelector(blotterSlice.selectors.getFilter);

  const handleFiltertypeChange = useCallback((value: DateFilterType) => {
    if (value === 'intraday') {
      dispatch(blotterSlice.actions.filterModified({ type: 'intraday' }));
      track('Filter: daterange modified', 'Intraday');
    } else {
      dispatch(blotterSlice.actions.filterModified({ type: 'historical', subtype: 'preset', preset: 'yesterday' }));
      track('Filter: daterange modified', 'Historical - yesterday');
    }
  }, []);

  if (filter === undefined) {
    // only case : failed to register to signalR notifications for trades
    return null;
  }

  // TODO restrict to not internal_sales and tab is not orders
  return (
    <>
      {filter.type === 'historical' && <HistoricalDaterangePicker />}
      <RadioButtonGroup
        options={[
          {
            label: formatMessage({ id: 'blotter.filters.date.type.historical' }),
            value: 'historical',
          },
          {
            label: formatMessage({ id: 'blotter.filters.date.type.intraday' }),
            value: 'intraday',
          },
        ]}
        size="sm"
        selectedValue={filter.type === 'intraday' ? 'intraday' : 'historical'}
        onChange={handleFiltertypeChange}
      />
    </>
  );
};
